import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
// import style from './style.css';
import {Icon} from '../../Icon';
import cx from '../../../../styles';
import { translate } from 'react-i18next';
import { gtmSend } from '../../../../helpers';

class ActionLink extends Component {

    constructor(props) {
        super(props);
        this.state = {showLinks : false};
    }

    componentDidMount(){
        document.addEventListener("keydown", this.escHandler, false);
        document.addEventListener('mousedown', this.outsideClickHandler);
    }

    componentWillUnmount(){
        document.removeEventListener("keydown", this.escHandler, false);
        document.removeEventListener('mousedown', this.outsideClickHandler);
    }

    handleClick = (cardName) => {
        this.setState({showLinks: !this.state.showLinks})
        if(cardName){
            gtmSend('dynamic',cardName,'click-more', this.props.match.path)
        }
    }

    onActionClick = (action, cardName) => {
        this.closePopout();

        if(action.handler){
           action.handler(); 
        }
        const sendEvent = (name, action) => {
            return gtmSend(name, `${cardName}`, action, `${this.props.topic? `${this.props.topic.name}`: '--'}`, 0, {card_type: `${cardName}`, topic_name:`${this.props.topic? `${this.props.topic.name}`: '--'}`, topic_id: `${this.props.topic? `${this.props.topic.id}`:'--'}`, [cardName === 'Reply Card'?'reply_id': 'card_id']: `${this.props.id}`})
        }
        if(cardName){
            gtmSend('dynamic', cardName, 'click-action', this.props.match.path);
            // new events
            switch(action.type) {
                case 'report':
                    sendEvent(`cw_report`, `Report`);
                break;
                case 'user_blocks_user':
                break;
                case 'report_user':
                    sendEvent(`cw_user_report`, `User Report`);
                break;
                case 'share':
                    sendEvent(`cw_share_click`, `Share`);
                break;
                case 'hide':
                    sendEvent(`cw_hide`, `Hide`);
                break;
                default:
                    sendEvent(`cw_${action.type}`, `${action.title}`);
            }
        }
    }

    closePopout = () => {
        this.setState({showLinks : false});
    }

    escHandler = (event) => {
        if(event.keyCode === 27) {
            this.closePopout();
        }
    }

    outsideClickHandler = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.closePopout();
        }
    }

    translate = (k) => {
        const t = this.props.t;
        let translatedVal;
        //match
        switch(k) {
            case 'Follow':
            translatedVal = t('community_action_follow');
            break;
            case 'Unfollow':
            translatedVal = t('community_action_unfollow');
            break;
            case 'Edit':
            translatedVal = t('community_action_edit');
            break;
            case 'Delete':
            translatedVal = t('community_action_delete');
            break;
            case 'Hide this post':
            translatedVal = t('community_action_hide_post');
            break;
            case 'Share':
            translatedVal = t('detail_share');
            break;
            case 'Skip this poll':
            translatedVal = t('community_action_skip_poll');
            break;
            default:
            translatedVal = k;
            break;
        }

        return translatedVal;
    }

    render() {
        const actionLinks = (
            <ul>
                {
                    this.props.actions.map((action, i) => {
                        return <li key={i} onClick={()=>this.onActionClick(action, this.props.cardName)} className={cx("pointer-click")}>{action.title}</li>
                    })
                }
            </ul>
        );

        return(
            <React.Fragment>
                <div className={cx("action-link", !this.props.actions.length && "hide")} ref={node=>this.wrapperRef=node}>
                    <span className={cx("pointer-click")} onClick={() => this.handleClick(this.props.cardName)}>
                        <Icon className={cx("not-mobile")} name="dot-more-regular-gray-sm" />
                        <Icon className={cx("only-mobile")}  name="dot-more-vertical-regular-gray-sm" />
                    </span>
                    <div className={cx("tooltip-card", (this.state.showLinks ? "active" : ""))} >{actionLinks}</div>
                </div>
            </React.Fragment>
        )
    }

}

export default translate()(ActionLink);
